<div class="qvs-login-page">
  <div class="qvs-login-page__surface-left">
    <ion-button
      [style.visibility]="(isNotLoginRoute$ | async) ? 'visible' : 'hidden'"
      qvsClickKeydownEnterSpace
      (clickAndKeydown)="cancelPolling()"
      class="qvs-login-page__surface-left__back-button"
    >
      <ion-icon slot="start" [src]="'assets/icons/back.svg'"></ion-icon>
      {{ 'ebanking.login.BACK' | translate }}
    </ion-button>
    <div
      class="qvs-login-page__surface-left__content"
      [class.qvs-login-page__surface-left__content--larger-padding]="isLargerPaddingNeeded$ | async"
    >
      <img class="qvs-login-page__surface-left__content__logo" alt="logo" [src]="logo | assetByColorMode" />
      <div class="qvs-login-page__surface-left__content__route-content">
        <router-outlet (activate)="updateBackgroundImages()"></router-outlet>
      </div>
    </div>

    <div class="qvs-login-page__surface-left__bottom">
      <qvs-version-info [isEbanking]="true"></qvs-version-info>

      <nav class="qvs-login-page__surface-left__bottom__navigation">
        <a
          class="qvs-login-page__surface-left__bottom__navigation__link"
          [routerLink]="[loginRoutePaths.COOKIE_POLICY]"
          routerLinkActive="active"
        >
          <qvs-svg-icon
            class="qvs-login-page__surface-left__bottom__navigation__link__icon"
            [src]="'assets/icons/cookie.svg'"
          ></qvs-svg-icon>
          {{ 'ebanking.login.COOKIE_POLICY' | translate }}
        </a>
        <a
          class="qvs-login-page__surface-left__bottom__navigation__link"
          [routerLink]="[loginRoutePaths.SECURITY_ADVICE]"
          routerLinkActive="active"
        >
          <qvs-svg-icon
            class="qvs-login-page__surface-left__bottom__navigation__link__icon"
            [src]="'assets/icons/lock.svg'"
          ></qvs-svg-icon>
          {{ 'ebanking.login.SECURITY_ADVICE' | translate }}
        </a>
        <a
          class="qvs-login-page__surface-left__bottom__navigation__link"
          [routerLink]="[loginRoutePaths.MOBILE]"
          routerLinkActive="active"
        >
          <qvs-svg-icon
            class="qvs-login-page__surface-left__bottom__navigation__link__icon"
            [src]="'assets/icons/mobile.svg'"
          ></qvs-svg-icon>
          {{ 'ebanking.login.MOBILE_APP' | translate }}
        </a>
        <a
          class="qvs-login-page__surface-left__bottom__navigation__link"
          [routerLink]="[loginRoutePaths.ABOUT]"
          routerLinkActive="active"
        >
          <qvs-svg-icon
            class="qvs-login-page__surface-left__bottom__navigation__link__icon"
            [src]="'assets/icons/info.svg'"
          ></qvs-svg-icon>
          {{ 'ebanking.login.ABOUT' | translate }}
        </a>
      </nav>
    </div>
  </div>
  <div class="qvs-login-page__background-right">
    <div *ngFor="let img of backgroundImages" aria-hidden="true" [class]="'qvs-login-page__background-right__' + img.class"></div>
  </div>
</div>
